import { digest } from 'json-hash';

import type { AssetForm } from './AssetForm';

function generateAssetFormHashCode(form: AssetForm): string {
  const {
    title,
    automatedTitle,
    synopsis,
    schemaType,
    categories,
    tags,
    embargoDate,
    expireDate,
    applyAutomatedTransitions,
    contentSharingBehavior,
  } = form;

  const obj = {
    title,
    automatedTitle,
    synopsis,
    schemaType,
    categories,
    tags,
    embargoDate,
    expireDate,
    applyAutomatedTransitions,
    contentSharingBehavior,
  };
  return digest(obj);
}

export default generateAssetFormHashCode;
